import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
// import { Map, Geosuggest } from 'components/misc'
import { Country } from 'containers/common'
import { Input, Textarea } from 'components/fields'
// import address from 'utils/address'

export default class AJEventAddress extends Component {
  // static propTypes = {
  //   data: PropTypes.object.isRequired,
  //   change: PropTypes.func.isRequired
  // }

  static defaultProps = {
    data: {}
  }

  constructor(props) {
    super(props)
    this.state = {
      location: {
        lat: 50.07461896310511,
        lng: 14.426893938476496
      },
      center: {
        lat: 50.07461896310511,
        lng: 14.426893938476496
      },
      zoom: 9,
      approxAddress: null,
      address: []
    }
  }

  // componentDidMount() {
  //   this.geocoder = new google.maps.Geocoder() // eslint-disable-line
  // }

  // componentWillReceiveProps(nextProps) {
  //   if (!this.props.data.location && nextProps.data.location) {
  //     this.handleCoordsByAddress(nextProps.data.location)
  //   }
  // }

  // handleClick = ({ lat, lng }) => {
  //   this.setState({
  //     ...this.state,
  //     location: {
  //       lat,
  //       lng
  //     }
  //   })
  //   this.handleAddressByCoord(lat, lng)
  // }

  // handleAddressSelect = data => {
  //   this.handleSetMapSettings({
  //     lat: data.location.lat,
  //     lng: data.location.lng,
  //     zoom: 15,
  //     newAddress: data.gmaps.address_components
  //   })
  //   this.handleAddressUpdate()
  // }

  // handleAddressByCoord = (lat, lng) => {
  //   const latLng = new google.maps.LatLng(lat, lng) // eslint-disable-line

  //   this.geocoder.geocode({ latLng }, result => {
  //     this.setState({
  //       ...this.state,
  //       approxAddress: result && result[0].formatted_address,
  //       address: result && result[0].address_components,
  //     })
  //     this.handleAddressUpdate()
  //   })
  // }

  // handleCoordsByAddress = newAddress => {
  //   this.geocoder.geocode({ address: newAddress }, result => {
  //     this.handleSetMapSettings({
  //       lat: result[0] && result[0].geometry.location.lat(),
  //       lng: result[0] && result[0].geometry.location.lng()
  //     })
  //   })
  // }

  // handleSetMapSettings = ({ lat, lng, zoom, newAddress }) => {
  //   this.setState({
  //     ...this.state,
  //     location: {
  //       lat,
  //       lng
  //     },
  //     center: {
  //       lat,
  //       lng
  //     },
  //     zoom: zoom || this.state.zoom,
  //     address: newAddress || this.state.newAddress,
  //   })
  // }

  // handleAddressUpdate = () => {
  //   const { route, premise, streetNumber, establishment } = address(this.state.address)

  //   this.props.change('location', `${route || establishment || ''} ${premise || ''}${(premise && streetNumber && '/') || ''}${streetNumber || ''}`)
  //   // this.props.change('otherLocationInformation', otherLocationInformation)
  //   // this.props.change('post_code', postalCode)
  // }

  render() {
    return (
      <div className="row">
        <div className="col-xs-6">
          <div className="row">
            <div className="col-xs-12">
              <h2>
                <FormattedMessage
                  id="moduleTitle.address"
                  defaultMessage="Address"
                />
              </h2>
            </div>
            <div className="col-xs-6">
              <Input
                label="Location"
                intlKey="label.location"
                name="location"
              />
            </div>
            <div className="col-xs-6">
              <Country formPrefix="" resetAward={false} />
            </div>
            <div className="col-xs-12">
              <Textarea
                label="Other location information"
                intlKey="label.other_location_information"
                name="otherLocationInformation"
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

// <div className='col-xs-12'>
//   <Geosuggest label='Find Address' intlKey='label.find_address' onSuggestSelect={this.handleAddressSelect} />
// </div>

// <div className="col-xs-6">
//   <Map onClick={this.handleClick} {...this.state} />
// </div>
